export const HomeSeo = () => (
  <section className="section" aria-labelledby="national-seo-heading">
    <div className="container mx-auto max-w-4xl px-4">
      <h2 id="national-seo-heading" className="text-3xl md:text-4xl font-bold mb-6 text-center">
        Video Ad Agency for Kitchen Remodeling and Home Service Companies Across the US
      </h2>
      <div className="space-y-5 text-muted-foreground text-base md:text-lg leading-relaxed">
        <p>
          The Alpha Omega Hub is a performance-focused video ad agency working with kitchen remodeling companies
          and home service businesses across the United States. We produce high-performing short-form video ads
          built to earn attention, build trust, and drive customer action for remodelers, contractors and home
          service brands.
        </p>
        <p>
          We specialise 100% in short-form video ads. Our team writes every script and directs every shoot
          in-house — no outsourcing to individual UGC creators — across multiple formats: indoor, outdoor,
          studio and on-location. Strategy, filming, editing and paid advertising work together as one system
          built to generate qualified leads and measurable business results.
        </p>
        <p>
          We work with no commitment, offer unlimited revisions, and deliver the V1 of your videos within
          10 days of the shoot. See the work we've produced for the brands we work with in our{' '}
          <a href="/case-studies" className="text-primary hover:underline">case studies</a>.
        </p>
      </div>
    </div>
  </section>
);
